import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login.vue';
import { queryAppEnvInfo, queryServerInfo } from '@/api/base';
import { getToken } from '@/utils/request';
import store from '@/store';
import Dashboard from './dashboard';

import ApplicationAnalysis from './application-analysis';
import ServiceAnalysis from './service-analysis';
import LogAnalysis from './log-analysis';
// import Index from './index/index';
// import Link from './link-manage';
// import Event from './event-manage';
// import EventRealTime from './event-manage-realtime';
import Visualization from './visualization';

Vue.use(VueRouter);

export const contantRoutes = [
  ...Dashboard,
  ...Visualization,
  ...ApplicationAnalysis,
  ...ServiceAnalysis,
  ...LogAnalysis,
  // ...Link,
  // ...Event,
  // ...EventRealTime,
  // ...Index,
];

const routes = [
  ...contantRoutes,
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  { path: '*', redirect: '/application-analysis/overview' },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== 'Login' && !getToken()) {
    return next({ name: 'Login' });
  }

  if (to.name === 'Login') {
    return next();
  }

  const { data: envInfo } = await queryAppEnvInfo();
  let {
    // eslint-disable-next-line prefer-const
    envs,
    // eslint-disable-next-line prefer-const
    topologyTypes,
  } = envInfo;
  const {
    bizChannels = [],
  } = envInfo;

  const BIZ_CHANNEL = store.getters['app/bizChannel'];
  const LOG_ENV = store.getters['app/env'];
  const LOG_SOURCE = store.getters['app/source'];
  const flows = [];
  if (bizChannels?.length) {
    bizChannels.forEach((item) => {
      flows.push({
        bizChannel: item.key,
        bizChannelName: item.name,
        env: item.flowEnv,
      });
    });
  }

  // 平台
  if (typeof BIZ_CHANNEL === 'undefined' || !BIZ_CHANNEL) {
    store.dispatch('app/setBizChannel', bizChannels?.[0]?.key || '');
  }

  // 环境
  if (typeof LOG_ENV === 'undefined' || !LOG_ENV) {
    store.dispatch('app/setEnv', envs[0].key);
  }

  let sources = [];

  const setSources = () => {
    const items = bizChannels.find((item) => item.key === store.getters['app/bizChannel']);
    sources = items?.sources || [];
  };

  // 来源
  if (typeof LOG_SOURCE === 'undefined' || !LOG_SOURCE) {
    if (BIZ_CHANNEL) {
      setSources();
    } else {
      sources = bizChannels[0].sources;
      store.dispatch('app/setSource', sources[0].key);
    }
  } else {
    setSources();
  }

  store.dispatch('app/setBizChannelList', bizChannels);
  store.dispatch('app/setSourceList', sources);
  store.dispatch('app/setEnvList', envs);
  store.dispatch('app/setFlowList', flows);
  store.dispatch('app/setTopologyTypeList', topologyTypes);

  // 应用，需要过滤掉不存在的 keys
  if (to.meta?.isUseAppInfo) {
    // bizChannels = bizChannels.filter((channel) => channel?.sources.length > 0);

    const findChannel = bizChannels.find(
      (channel) => channel.key === store.getters['app/bizChannel'],
    );
    // if (!findChannel) {
    sources = findChannel?.sources || [];
    console.log('findChannel', findChannel, 'sources', sources);
    // store.dispatch('app/setBizChannelList', bizChannels || []);
    // store.dispatch('app/setBizChannel', bizChannels?.[0]?.key || '');
    store.dispatch('app/setSourceList', sources);
    // console.log(LOG_SOURCE, 'LOG_SOURCE');
    // store.dispatch('app/setSource', sources?.[0]?.key || '');
    // }
  }

  // 需要跳转的页面使用服务, 根据当前选择的环境加载服务列表
  if (to?.meta?.isUseServerInfo) {
    // 获取服务列表
    const { data: serverInfo } = await queryServerInfo({
      bizChannel: store.getters['app/bizChannel'] || '',
    });

    // 处理数据
    let serverInfos = [
      ...serverInfo.serverInfos.map((item) => ({
        key: item.serverName,
        name: item.serverName,
      })),
    ];

    serverInfos = [
      {
        key: '',
        name: '全部服务',
      },
      ...serverInfos,
    ];

    // 判断当前的参数
    if (!store.getters['app/serverName'] && serverInfos.length > 0) {
      store.dispatch('app/setServerName', serverInfos[0].key);
    }

    if (serverInfos.length === 0) {
      store.dispatch('app/setServerName', '');
    }

    store.dispatch('app/setServerList', serverInfos);
  }

  return next();
});

export default router;
